<h2 mat-dialog-title>Select communication channel</h2>
<mat-dialog-content>
	<p>Select WhatsApp or SMS to send your message</p>
</mat-dialog-content>
<div mat-dialog-actions>
	<button mat-stroked-button mat-dialog-close (click)="sms()">SMS</button>
	<button mat-stroked-button mat-dialog-close style="color: green" (click)="wa()">WHATSAPP (TRIAL)</button>
</div>
